import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const POLL_MS = 5 * 60 * 1000;

/** Yayındaki sürüm kimliği; dosya yoksa (geliştirme) ya da ağ hatasında null. */
async function fetchVersion() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return typeof data?.version === "string" ? data.version : null;
  } catch {
    return null;
  }
}

/**
 * Yeni sürüm yayınlanınca sayfayı kendiliğinden yeniler. Açılıştaki sürüm
 * kimliği saklanır; 5 dakikada bir ve sekmeye dönülünce yoklanır. Değişince
 * girilmiş ama kaydedilmemiş veri kaybolmasın diye hemen değil, kullanıcı
 * başka sayfaya geçtiğinde yenilenir; o zamana kadar altta "Yenile" şeridi.
 */
export default function UpdateWatcher() {
  const location = useLocation();
  const baseline = useRef(null);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const current = await fetchVersion();
      if (cancelled || !current) return;
      if (!baseline.current) baseline.current = current;
      else if (current !== baseline.current) setPending(true);
    };
    check();
    const timer = setInterval(check, POLL_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  // Sayfa değişince yeni sürüm yüklenir.
  const lastPath = useRef(location.pathname);
  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;
    if (pending) window.location.reload();
  }, [location.pathname, pending]);

  if (!pending) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[1500] flex items-center gap-3 rounded-full px-4 py-2 text-sm shadow-lg bg-terakkiPrimaryDark text-white dark:bg-white dark:text-terakkiPrimaryDark"
    >
      <span>Yeni sürüm hazır</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="font-SemiBold underline underline-offset-2"
      >
        Yenile
      </button>
    </div>
  );
}
